import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import GlobalTopMessage from '../components/GlobalTopMessage'
import { actionCreators } from '../actions'
import { globalTopMessagePropsSelector } from '../selectors'

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(actionCreators, dispatch)

const mapStateToProps = (state) => globalTopMessagePropsSelector(state)

export default connect(mapStateToProps, mapDispatchToProps, undefined, {
  pure: false,
})(GlobalTopMessage)
